import React from "react";
import { PAGES_ENDPOINTS } from "../constants/Endpoints";
import { Navigate } from "react-router-dom";

const DefaultRoute = () => {
  return <Navigate to={PAGES_ENDPOINTS.LOGIN} />;
};

export default DefaultRoute;
